import { additionNameGroup } from "components/PropertyPanel/PropertyPanel";
import { User } from "models/User";
import { create } from "zustand";

interface SelectedDesign {
  designId: number;
  previousDesignId: number;
  designUpdated: boolean;
  hasPressure: boolean;
  hasRondomImage: boolean;
  templateReplaced: boolean;
  setDesignId: (id: number) => void;
  additionListNamesFromServer: additionNameGroup[] | null;
  createdBy: User | null;
  setCreatedBy: (user: User | null) => void;
  lengthFromWBCT: number;
  printTaskId : number | null;
}

export const useSelectedDesignStore = create<SelectedDesign>((set) => ({
  designId: -1,
  previousDesignId: -1,
  designUpdated: false,
  hasPressure: false,
  hasRondomImage: false,
  templateReplaced: false,
  adminPageNumber: null,
  additionListNamesFromServer: [],
  createdBy: null,
  lengthFromWBCT: -1,
  printTaskId : -1,

  setDesignId: (id: number) => {
    set({ designId: id });
  },
  setCreatedBy(user: User | null) {
    set({ createdBy: user })
  }
}));